import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const COUNT = 9;
const SECONDS = 30;

export const MiniPack = () => (
  <img src="/img/gacha/pack-sm.webp" alt="BagiPulsa Digital Booster Pack" draggable="false" className="pack-shine h-full w-full select-none drop-shadow-[0_20px_30px_rgba(0,0,0,0.6)]" />
);

export const PreparingStep = ({ onDone }) => {
  useEffect(() => {
    ["/img/gacha/pack.webp", "/img/gacha/pack-sm.webp"].forEach((src) => {
      new Image().src = src;
    });
    const t = setTimeout(onDone, 1600);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <div data-testid="gacha-preparing" className="w-full max-w-xs text-center">
      <p className="font-display text-xl text-paper">Menyiapkan hadiah…</p>
      <div className="mt-5 h-2 overflow-hidden rounded-full bg-white/10">
        <motion.div className="h-full rounded-full bg-gradient-to-r from-volt to-lime" initial={{ width: "0%" }} animate={{ width: "100%" }} transition={{ duration: 1.4, ease: "easeInOut" }} />
      </div>
    </div>
  );
};

export const PackChooser = ({ title, onPick }) => {
  const track = useRef(null);
  const [center, setCenter] = useState(Math.floor(COUNT / 2));
  const [left, setLeft] = useState(SECONDS);

  const scrollTo = (i, smooth = true) => {
    const el = track.current?.children[i];
    if (el) track.current.scrollTo({ left: el.offsetLeft - (track.current.clientWidth - el.clientWidth) / 2, behavior: smooth ? "smooth" : "auto" });
  };
  useEffect(() => {
    scrollTo(Math.floor(COUNT / 2), false);
  }, []);
  useEffect(() => {
    if (left <= 0) {
      onPick(center);
      return undefined;
    }
    const t = setTimeout(() => setLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [left, center, onPick]);

  const onScroll = () => {
    const el = track.current;
    if (!el) return;
    const mid = el.scrollLeft + el.clientWidth / 2;
    let best = 0, dist = Infinity;
    Array.from(el.children).forEach((c, i) => {
      const d = Math.abs(c.offsetLeft + c.clientWidth / 2 - mid);
      if (d < dist) { dist = d; best = i; }
    });
    setCenter(best);
  };
  const dragRef = useRef(null);
  const onDown = (e) => {
    if (e.pointerType !== "mouse") return;
    dragRef.current = { x: e.clientX, left: track.current.scrollLeft, moved: false };
    track.current.style.scrollSnapType = "none";
  };
  const onMoveDrag = (e) => {
    const d = dragRef.current;
    if (!d) return;
    if (Math.abs(e.clientX - d.x) > 5) d.moved = true;
    track.current.scrollLeft = d.left - (e.clientX - d.x);
  };
  const onUpDrag = () => {
    const d = dragRef.current;
    if (!d) return;
    dragRef.current = null;
    track.current.style.scrollSnapType = "";
    scrollTo(center);
    if (d.moved) track.current.dataset.justDragged = "1";
  };
  const tap = (i) => {
    if (track.current?.dataset.justDragged) {
      delete track.current.dataset.justDragged;
      return;
    }
    if (i === center) onPick(i);
    else scrollTo(i);
  };

  return (
    <div data-testid="gacha-pack-chooser" className="flex w-full flex-col items-center">
      <p className="font-display text-xl text-paper md:text-2xl">Pilih pack kamu</p>
      <div className="mt-8 w-screen max-w-4xl [mask-image:linear-gradient(90deg,transparent,black_15%,black_85%,transparent)]">
      <div ref={track} onScroll={onScroll} onPointerDown={onDown} onPointerMove={onMoveDrag} onPointerUp={onUpDrag} onPointerLeave={onUpDrag} data-lenis-prevent="" className="no-scrollbar relative flex w-full cursor-grab touch-pan-x snap-x snap-mandatory gap-2 overflow-x-auto overscroll-x-contain px-[calc(50%-75px)] py-10 active:cursor-grabbing">
        {Array.from({ length: COUNT }, (_, i) => (
          <motion.button
            key={i}
            data-testid={`gacha-pack-option-${i}`}
            onClick={() => tap(i)}
            animate={{ scale: i === center ? 1.08 : 0.82, opacity: i === center ? 1 : 0.45, y: i === center ? -8 : 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 24 }}
            className="h-[237px] w-[150px] shrink-0 snap-center"
            aria-label={`Pack ${i + 1}`}
          >
            <MiniPack />
          </motion.button>
        ))}
      </div>
      </div>
      <div className="relative mt-2 grid h-16 w-16 place-items-center" data-testid="gacha-countdown">
        <svg viewBox="0 0 36 36" className="absolute inset-0 -rotate-90">
          <circle cx="18" cy="18" r="16" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="3" />
          <circle cx="18" cy="18" r="16" fill="none" stroke="#FFC21A" strokeWidth="3" strokeDasharray="100.5" strokeDashoffset={100.5 * (1 - left / SECONDS)} strokeLinecap="round" style={{ transition: "stroke-dashoffset 1s linear" }} />
        </svg>
        <span className="font-display text-lg text-paper">{left}</span>
      </div>
      <p className="mt-4 text-center text-sm text-zinc-300">Geser pack ke kiri atau kanan, lalu ketuk pack di tengah</p>
    </div>
  );
};
